<template>
  <div id="app">
    <div
      v-if="progressing"
      class="
        skeleton-2
        bg-white
        border-width-1 border-solid
        m-2xl
        p-m
        border-gray-200
      "
    />
    <router-view v-else/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import projectsService from '@/services/project';
import { getNewEndpoint } from './config/newEndpoint';

export default {
  name: 'App',
  computed: {
    ...mapGetters('endpoint', ['currentEnvironment']),
    minProject() {
      if (this.currentEnvironment === 'manage') return 0;
      return 1;
    },
  },
  created() {
    getNewEndpoint();
    this.getProject();
  },
  data() {
    return {
      total: 0,
      progressing: true,
    };
  },
  methods: {
    async getProject() {
      try {
        const params = {
          limit: 100,
          sort: 'created_at:asc',
        };
        this.progressing = true;
        const res = await projectsService.listProjects(params);
        this.total = res?.metadata?.total;
        if (this.total === this.minProject) {
          this.$router.push('/intro');
        }
        this.progressing = false;
      } catch (error) {
        this.progressing = false;
      }
    },
  },
};
</script>
